export default __webpack_public_path__ + "static/media/arrow-left.2dc77c6d.svg";